import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import type { TLandingFormFields } from 'entities/creditForm';

import {
  FormFieldsControls as ContactsInfoFormFieldsControls,
  FormFieldsNavigationSequence as ContactsInfoFormFieldsNavigationSequence,
} from 'features/UpdateContactsInfo';
import {
  FormFieldsControls as CreditPurposeInfoFormFieldsControls,
  FormFieldsNavigationSequence as CreditPurposeInfoFormFieldsNavigationSequence,
} from 'features/UpdateCreditPurposeInfo';
import { FormFieldsControls as PassportInfoFormFieldsControls } from 'features/UpdatePassportInfo';

export interface ICreditPurposeInfoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TLandingFormFields;
}

export const FormFieldsControls: Record<keyof TLandingFormFields, React.ReactNode> = {
  ...CreditPurposeInfoFormFieldsControls,
  ...ContactsInfoFormFieldsControls,
  ...PassportInfoFormFieldsControls,
};

export const FormFieldsNavigationSequence: ICreditPurposeInfoMobileConfig[] = [
  ...CreditPurposeInfoFormFieldsNavigationSequence,
  ...ContactsInfoFormFieldsNavigationSequence,
];
